<template>
  <div>
    <LoadingSpinner v-if="loading"/>

    <div v-else class="panel panel-default">
      <div class="panel-body">
        <form @submit.prevent="submit" class="form-horizontal">
          <TextFormGroup
              v-model="data.name"
              name="name"
              label="Name"
              :error="(errors.name || [])[0]"
          />

          <TextFormGroup
              v-model="data.url"
              name="url"
              label="URL"
              :error="(errors.url || [])[0]"
          />

          <GalleryFormGroup
              v-model="data.image_id"
              name="image_id"
              label="Image"
              :error="(errors.image_id || [])[0]"
          />

          <hr>

          <SubmitFormGroup button-class="btn-black"/>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import GalleryFormGroup from '@/components/FormGroups/Horizontal/Gallery'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'
import LoadingSpinner from "../../../../../../components/Layout/LoadingSpinner.vue";

export default {
  components: {
    LoadingSpinner,
    GalleryFormGroup,
    SubmitFormGroup,
    TextFormGroup,
  },

  mixins: [Errors],

  props: {
    brandId: {
      required: true
    }
  },

  data() {
    return {
      data: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      this.loading = true

      http.get('/api/v2/brands/' + this.brandId)
          .then(response => {
            this.data = response.data.data.attributes

            this.loading = false
          })
    },

    submit() {
      http.put('/api/v2/brands/' + this.brandId, this.data)
          .then(response => {
            notify.success('The brand was saved')

            this.data = response.data.data.attributes
          })
          .catch(this.catchValidationErrors)
    }
  }
}
</script>
